import Application from "../../Application";
import { IInstitutionDetails } from "../../organisations/model/InstitutionDetails";
import { IOrganisation } from "../../organisations/model/Organisation";

import OrganisationDetailsPresenter, {
  IOrganisationDetailsPresenter
} from "../presenter/OrganisationDetailsPresenter";
import GetInstitutionDetailsInteractor from "../../organisations/interactors/GetOrganisationInstitutionDetailsInteractor";
import GetOrganisationInteractor from "../../organisations/interactors/GetOrganisationInteractor";
export default class ShowOrganisationDetailsInteractor {
  private application: Application;
  private output?: IOrganisationDetailsPresenter;
  private getOrganisationInteractor: GetOrganisationInteractor;
  private getInstitutionDetailsInteractor: GetInstitutionDetailsInteractor;

  constructor({ application, getOrganisation, getInstitutionDetails }) {
    this.application = application;
    this.getOrganisationInteractor = getOrganisation;
    this.getInstitutionDetailsInteractor = getInstitutionDetails;
  }

  execute(organisationId) {
    this.output = Object.assign(
      OrganisationDetailsPresenter({
        application: this.application,

        initialState: {
          organisation: {} as IOrganisation,
          institutionDetails: {} as IInstitutionDetails
        }
      })
    );
    this.getInstitutionDetailsInteractor
      .execute(organisationId)
      .then((institutionDetails) =>
        this.output?.loadReferenceValues(institutionDetails)
      );
    this.getOrganisationInteractor
      .execute(organisationId)
      .then((organisation) => this.output?.loadOrganisation(organisation));

    return this.output;
  }
}
